var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            width: 90,
            "footer-hide": true,
            title: "产品审核",
            "class-name": "vertical-center-modal",
          },
          on: { "on-visible-change": _vm.onShowChange },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.mainTable.sarchCardShow
                ? _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c("search-card", {
                            attrs: {
                              form: _vm.mainTable.searchForm,
                              "table-load-event": _vm.getMainTableRecords,
                              "table-search": _vm.mainTable.tableSearch,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "Card",
            { attrs: { padding: 0, bordered: false, "dis-hover": true } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c("Col", { attrs: { span: "24" } }, [
                    _c("div", { staticClass: "global-tool-bar" }, [
                      _c(
                        "div",
                        { staticClass: "left-bar" },
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("未提交审批产品"),
                          ]),
                          _c(
                            "Button",
                            {
                              staticClass: "btns",
                              staticStyle: { "margin-left": "30px" },
                              attrs: {
                                type: "primary",
                                size: "small",
                                shape: "circle",
                                icon: "ios-search",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.mainTable.sarchCardShow =
                                    !_vm.mainTable.sarchCardShow
                                },
                              },
                            },
                            [_vm._v("搜索")]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "right-bar" }),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "18" } },
                    [
                      _c("stand-pagination-table", {
                        attrs: {
                          columns: _vm.mainTable.tableColumns,
                          data: _vm.mainTable.tableData,
                          loading: _vm.mainTable.tableLoading,
                          "page-size-options": [5],
                          "table-search": _vm.mainTable.tableSearch,
                          "table-load-event": _vm.getMainTableRecords,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "Card",
                        [
                          _vm.innerSpin
                            ? _c("Spin", { attrs: { size: "large", fix: "" } })
                            : _vm._e(),
                          _c("p", { attrs: { slot: "title" }, slot: "title" }, [
                            _vm._v("已添加产品"),
                          ]),
                          _c(
                            "Button",
                            {
                              staticClass: "btns",
                              attrs: {
                                slot: "extra",
                                type: "success",
                                size: "small",
                              },
                              on: { click: _vm.onSubmit },
                              slot: "extra",
                            },
                            [_vm._v("提交")]
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "24" } },
                                _vm._l(_vm.productAddedList, function (p) {
                                  return _c(
                                    "Tag",
                                    {
                                      key: p.productUuid,
                                      staticStyle: { "font-size": "18px" },
                                      attrs: {
                                        name: p.productUuid,
                                        type: "border",
                                        closable: "",
                                        color: "warning",
                                      },
                                      on: {
                                        "on-close": _vm.onRemoveAddedProduct,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(p.productName) +
                                          "（" +
                                          _vm._s(p.productCode) +
                                          "）"
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }